module.exports = __webpack_public_path__ + "static/img/bottomLogo.583f680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottomLogo.png
// module id = oZ5i
// module chunks = 1